<template>
<div>
  <div class="form-group row">
    <label for="" class="col-sm-2">等級</label>
    <div class="col-sm-10">
      <label for="" class="col-sm-5">{{ data.riskLevelText |nullToEmpty }}  建議回診周期 {{ data.riskLevelBackHospitalDays |nullToEmpty }} 日</label>
<!--      <p style="color:red">S  (嚴重*)</p>-->
<!--      <p style="color:deeppink">A  (嚴重)</p>-->
<!--      <p style="color:#ba8b00">B  (需注意)</p>-->
<!--      <p style="color:green">C  (一般)</p>-->
    </div>
    <label for="" class="col-sm-2">最後就診日</label>
    <div class="col-sm-10">
      <label for="" class="col-sm-5">{{ dataProfile.lastBackHospitalDate |nullToEmpty   }}</label>
<!--      <p style="color:red">S  (嚴重*)</p>-->
<!--      <p style="color:deeppink">A  (嚴重)</p>-->
<!--      <p style="color:#ba8b00">B  (需注意)</p>-->
<!--      <p style="color:green">C  (一般)</p>-->
    </div>

    <label for="" class="col-sm-2">額外建議(個管師)</label>
    <div class="col-sm-10">
        <a class="btn btn-primary" href="#" @click="saveData()"><i class="fa fa-save"></i> 儲存</a>
        <textarea class="form-control" id="txtMemo" name="txtMemo" rows="10" v-model="data.caseManagerSuggest">
        </textarea>

    </div>

  </div>



<!--  <div class="form-group row">-->
<!--    <label for="" class="col-sm-2">上次回診日</label>-->
<!--    <div class="col-sm-10">-->
<!--      2021-12-1   (個案於2021-12-3 回覆)-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="form-group row">-->
<!--    <label for="" class="col-sm-2">建議回診日</label>-->
<!--    <div class="col-sm-10">-->
<!--      <input type="date" class="form-control" value="2022/1/1">-->

<!--    </div>-->
<!--  </div>-->
</div>
</template>

<script>
import apiTzsci from "@/views/tzsci/js/apiTzsci";
import util from "@/util/util";

export default {
  props: ['userId','data','dataProfile'],
  data: function() {
    return {
      formData:{
        name:"Sophie Wang",
      },
      submitted: false,
      suggest:"",
    };
  },
  methods: {
    getFullName: function() {
      return this.firstName + ' ' + this.user.lastName;
    },
    async loadData(){
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    async saveData(){
      await apiTzsci.api_Admin_UpdateSuggest_caseManagerSuggest(this.userId,this.data.caseManagerSuggest);
      await util.ShowMessage('儲存成功')
    }
  },
  mounted() {
    // let recaptchaScript = document.createElement('script')
    // recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
    // document.head.appendChild(recaptchaScript)

    //this.loadData()
  },
}

</script>

<style scoped>

</style>
